import Constants, { INPROGRESS_PAGE } from '../../utils/Constants';
import Variables from '../../style/variables.scss';
import heroImage from '../../assets/imgs/home/hero.webp';
import paralaxImage from '../../assets/imgs/home/parallax.webp';
import Paralax from '../../components/paralax/Paralax';
import About from './about/About';
import InProgress from './inProgress/InProgress';
import Finished from './finished/Finished';
import { CapitalizeFirstLetter } from '../../utils/CapitalizeFirstLetter';
import { useEffect } from 'react';
import map from '../../assets/imgs/split_map.webp';
import Advantage from './advantage/Advantage';
import HorizontalScroll from '../../components/horizontalScroll/HorizontalScroll';
import Gallery from './gallery/Gallery';
import { useLocation, useNavigate } from 'react-router-dom';
import scrollToPage from '../../utils/ScrollToLink';
import Progress from './progress/Progress';

const gallery = require.context('../../assets/imgs/home/gallery', true);
const galleryList = gallery.keys().map((image: any) => gallery(image));

const Home = () => {
  const location = useLocation();
  const navigate = useNavigate();
  let header: HTMLElement | null = document.getElementById('nav_container');

  useEffect(() => {
    document.title = `${CapitalizeFirstLetter(Constants.PROPERTY_NAME)}`;
    document.body.classList.remove('lock_scroll');
  }, []);

  setTimeout(() => {
    if (header !== null) {
      header.style.top = '0';
    }
  }, 1200);
  return (
    <div id={Constants.HOME} className='home body_wrapper'>
      <div className='home_container_hero'>
        <img src={heroImage} alt='hero' />
        <div className='home_container_hero_overlay'></div>
        <a
          href={INPROGRESS_PAGE}
          className='home_container_hero_overlay_button button_dark'
        >
          <div className='opacity_transition_low'>PONUDA STANOVA</div>
        </a>
      </div>
      <h1 hidden>{Constants.PROPERTY_NAME}</h1>
      <About />
      <Paralax
        topColor={Variables.secondaryColor}
        bottomColor={Variables.secondaryColor}
        children={
          <img
            src={paralaxImage}
            alt='paralax home'
            style={{
              position: 'absolute',
              top: 0,
              minWidth: '100%',
              minHeight: '100%',
              objectPosition: 'center',
              zIndex: 0,
            }}
          />
        }
      />
      <InProgress location={location} navigate={navigate} />
      <Progress />
      <div className='home_horizontal_scroll'>
        <HorizontalScroll />
      </div>
      <div className='home_horizontal_scroll_unable'>
        <p data-aos='fade-up'>
          <b>168</b> STANOVA
        </p>
        <p data-aos='fade-up' data-aos-delay='50'>
          <b>151</b> GARAŽNIH MJESTA
        </p>
        <p data-aos='fade-up' data-aos-delay='100'>
          <b>6</b> POSLOVNIH PROSTORA
        </p>
        <p data-aos='fade-up' data-aos-delay='150'>
          <b>36</b> VANJSKIH PARKIRINH MJESTA
        </p>
      </div>
      <Advantage />
      <Finished />
      <Paralax
        topColor={Variables.secondaryColor}
        bottomColor={Variables.primaryColor}
        children={
          <div style={{ position: 'relative' }}>
            <div
              style={{
                backgroundImage: `url(${map})`,
                backgroundPosition: '50%',
                backgroundRepeat: 'no-repeat',
                minHeight: 1080,
              }}
            ></div>
            <div
              style={{
                position: 'absolute',
                top: 0,
                width: '100%',
                height: '100%',
                backgroundColor: Variables.auxNeutral,
                filter: 'opacity(0.3)',
                zIndex: 1,
              }}
            ></div>
            <a
              style={{ position: 'absolute', top: 460, left: '50%', zIndex: 2 }}
              href='https://maps.app.goo.gl/U3fALU3PraNwbpLH9'
              className='opacity_transition_low'
            >
              <svg
                height='42px'
                width='42px'
                version='1.1'
                id='Layer_1'
                viewBox='0 0 512 512'
              >
                <path
                  style={{ fill: '#FF6243' }}
                  d='M256,0C154.739,0,72.348,82.386,72.348,183.652c0,67.027,16.956,92.392,148.945,289.772
    l20.826,31.157C245.217,509.217,250.424,512,256,512s10.782-2.783,13.881-7.418l17.369-25.978
    c135.054-202.011,152.402-227.967,152.402-294.951C439.652,82.386,357.261,0,256,0z M256,267.13
    c-46.032,0-83.478-37.446-83.478-83.478s37.446-83.478,83.478-83.478s83.478,37.446,83.478,83.478S302.032,267.13,256,267.13z'
                />
                <path
                  style={{ fill: '#FF3501' }}
                  d='M256,0v100.174c46.032,0,83.478,37.446,83.478,83.478S302.032,267.13,256,267.13V512
    c5.576,0,10.782-2.783,13.881-7.418l17.369-25.978c135.054-202.011,152.402-227.967,152.402-294.951C439.652,82.386,357.261,0,256,0
    z'
                />
              </svg>
            </a>
          </div>
        }
      />
      <Gallery imageList={galleryList} />
    </div>
  );
};

export default Home;
